import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "concierge__time_picker",
  "use": "concierge__time_picker-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"concierge__time_picker\">\n  <circle stroke-width=\"1.5\" cx=\"10\" cy=\"10\" r=\"9.25\" />\n  <rect x=\"9.75\" y=\"4.5\" width=\"1\" height=\"6\" rx=\".5\" fill=\"#fff\" stroke=\"#fff\" />\n  <rect x=\"9.75\" y=\"9.7\" width=\"4.4\" height=\"1\" rx=\".5\" fill=\"#fff\" stroke=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol